import { LayoutAPI } from '../../../api/bussched/LayoutAPI';

export class LayoutCommand {
    constructor() {
        this.layoutApi = new LayoutAPI();
    }

    list(successCallback, errorCallback) {
        const apiResult = this.layoutApi.list();
        apiResult.then((result) => {
            if (undefined !== successCallback) {
                successCallback(JSON.parse(result));
            }
        }).catch(() => {
            if (undefined !== errorCallback) {
                errorCallback("Ocorreu um erro a ler as configurações dos layouts");
            }
        });
    }

    save(data, successCallback, errorCallback) {
        if (0 >= data.name.length) {
            return;
        }

        const dataToSend = {
            id: data.id,
            name: data.name,
            width: data.width,
            height: data.height,
            components: []
        }

        for (const idx in data.components) {
            dataToSend.components.push({
                id: data.components[idx].id,
                type: data.components[idx].type,
                dataIdentifier: data.components[idx].dataIdentifier,
                configuration: data.components[idx].configuration,
                parameters: data.components[idx].parameters,
                positionAxisX: data.components[idx].absolutePositionAxisX,
                positionAxisY: data.components[idx].absolutePositionAxisY,
                positionAxisZ: data.components[idx].positionZ,
                width: data.components[idx].width,
                height: data.components[idx].height,
                fonts: undefined === data.components[idx].fonts ? [] : data.components[idx].fonts.map(font => Object.assign({}, font)),
                backgrounds: undefined === data.components[idx].backgrounds ? [] : data.components[idx].backgrounds.map(background => Object.assign({}, background)),
                margins: undefined === data.components[idx].margins ? [] : data.components[idx].margins.map(background => Object.assign({}, background)),
                circleElements: undefined === data.components[idx].circleElements ? [] : data.components[idx].circleElements.map(circleElement => Object.assign({}, circleElement))
            });
        }

        let apiResult = undefined;
        if (0 === dataToSend.id) {
            apiResult = this.layoutApi.create(dataToSend);
        }
        else {
            apiResult = this.layoutApi.update(dataToSend.id, dataToSend);
        }

        apiResult.then((result) => {
            if (undefined !== successCallback) {
                successCallback(JSON.parse(result));
            }
        }).catch(() => {
            if (undefined !== errorCallback) {
                errorCallback("Ocorreu um erro a gravar a configuração do layout");
            }
        });
    }

    delete(layoutId, successCallback, errorCallback) {
        const apiResult = this.layoutApi.delete(layoutId);
        apiResult.then((_) => {
            if (undefined !== successCallback) {
                successCallback(layoutId, "Layout eliminado com sucesso");
            }
        }).catch(() => {
            if (undefined !== errorCallback) {
                errorCallback("Ocorreu um erro a eliminar a configuração do layout");
            }
        });
    }
}



// WEBPACK FOOTER //
// ./src/components/bussched/commands/LayoutCommand.js